// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  // Demo call
  // https://app.devfra.com/digital-signage/?quickCode=1ESW7&appId=966&eventId=710&companyToken=uPclmJR&companyId=98
  production: false,
  api: {
    // Production backend
    base: 'https://app.highattendance.com/api/v2/',
    // base: 'https://dtc.devfra.com/api/v2/',
    // Example of URL for getting sessions of a certain event:
    // https://app.highattendance.com/api/v2/sessions-info?event_id=710&token=uPclmJR
    sessions: {
      path: 'sessions-info',
      token: 'uPclmJR'
    },
    // Example of URL for getting advertisements of a certain event:
    // https://app.highattendance.com/api/v2/advertisements?event_id=710&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjE5ODcsImlzcyI6Imh0dHBzOi8vYXBwLmhpZ2hhdHRlbmRhbmNlLmNvbS9hcGkvdjIvYXV0aGVudGljYXRlIiwiaWF0IjoxNTIyNjEwMDc5LCJleHAiOjE1NDk2MTAwNzksIm5iZiI6MTUyMjYxMDA3OSwianRpIjoiS2V2MDcwU0I0dUtoaWg2UCJ9.qjoQRgJ47WnbZVilQYwbz7J7iTrbWsJChrdsWlK6hvw
    ads: {
      path: 'advertisements-info',
      token: 'uPclmJR',
      enabled: false
    }
  },
  firebase: {
    apiKey: 'AIzaSyA62JZCXG4Hk-4BZWbtqcwxMy5djviSuZk',
    authDomain: 'high-attendance-notifications.firebaseapp.com',
    databaseURL: 'https://high-attendance-notifications.firebaseio.com',
    projectId: 'high-attendance-notifications',
    storageBucket: 'high-attendance-notifications.appspot.com',
    messagingSenderId: '1034885050072'
  },
  s3: {
    host: 'https://s3.us-west-2.amazonaws.com/',
    bucket: 'files.highattendance.com/',
    path: 'dev/'
  },
  posters: {
    // Set to true to enable the "On Demand" mode for poster presentation
    isOnDemand: true,
    // sourceUrl: '../../assets/sessions.json'
    // Demo source
    // sourceUrl: 'http://direct.betterabstracts.com/demo/rest/demo?_format=json'
    // sourceUrl: 'https://eposters.betterevents.io/ecg2020/web/rest/sessions',
    // sourceUrl: 'https://eposters.betterevents.io/eso2020/web/rest/sessions',
    // sourceUrl: 'https://eposters.betterevents.io/haema2020/web/rest/sessions',
    sourceUrl: 'https://eposters.betterevents.io/derm2020/web/rest/sessions',
    // Enable/Disable the navigation between the posters and the search field
    navigationDisabled: true,
    // Enable/Disable the debug mode. If enabled the posters that are not
    // submitted are displayed along with the submitted ones.
    isDebug: false
  }
};
